import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { DashboardService } from './services/dashboard/dashboard.service';
import { UserDataService } from './services/user-data.service';
import { MicrofrontendInboxService } from './microfrontend-inbox/microfrontend-inbox.service';
import { environment } from '../environments/environment';
import { AuthOrchestratorService, AuthStartupHandlers } from './auth/auth-orchestrator.service';
import { AuthModeService } from './auth/auth-mode.service';
import { AuthPromptService } from './auth/auth-prompt.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // Public state
  adkReady = true;
  title = 'symphony-ui';
  showSpinner = false;
  showMicroUi: boolean;
  notShowMicroUi: boolean;
  loginUserInfo: boolean;
  folderName = '';
  inquiryIdParam: any[] = [];
  accessType: any;
  entityTypeParam: any;
  productFamilyParam: any;
  dealStatusParam: any;
  entityDetails: any[] = [];
  inquiriesObjectParam: any[] = [];
  /** Shown when we've triggered IdP/CoT login and are waiting for redirect (avoids blank page). */
  redirectingToLogin = false;

  constructor(
    public dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    private userDataService: UserDataService,
    private microfrontendInboxService: MicrofrontendInboxService,
    private readonly oauthService: OAuthService,
    private readonly authOrchestrator: AuthOrchestratorService,
    private readonly authModeService: AuthModeService,
    public readonly authPromptService: AuthPromptService
  ) {
    this.showSpinner = true;
    if (environment.ACTIVE_DIRECTORY_AVAILABLE_FOR_SUGGESTIONS) {
      // QMA-1747: Active Directory suggestions – MSAL can be initialized here when enabled
    }
    setTimeout(() => {
      this.showSpinner = false;
      const handlers: AuthStartupHandlers = {
        onAppReady: () => this.loadApplication(),
        setRedirectingToLogin: (redirecting: boolean) => {
          this.redirectingToLogin = redirecting;
        },
        setAdkReady: (ready: boolean) => {
          this.adkReady = ready;
        }
      };
      this.authOrchestrator.bootstrapAppForCurrentRoute(handlers);
    });
  }

  loadApplication(): void {
    const urlHref = typeof (globalThis as any).location?.href === 'string' ? (globalThis as any).location.href : '';
    const hasOpenWith = urlHref.includes('openWith');
    if (!hasOpenWith) {
      this.notShowMicroUi = true;
    }

    if (this.activatedRoute?.queryParams) {
      this.activatedRoute.queryParams.subscribe(params => {
        const urlName = (globalThis as any).location?.href ?? '';
        const indexOfValue = urlName.indexOf('openWith');
        if (indexOfValue > -1) {
          if (params.openWith === 'microUi') {
            this.showMicroUi = true;
            this.folderName = 'INBOX';
            (globalThis as any).addEventListener?.('message', (event: MessageEvent) => {
              const loc = (globalThis as any).location;
              if (event?.origin === loc?.origin && event?.data?.['appName'] === 'BMW') {
                this.accessType = event.data.accessType ?? '';
                this.entityDetails = event.data.entityList ?? [];
                this.productFamilyParam = event.data.productFamily ?? '';
                this.entityTypeParam = event.data.entityType ?? '';
                this.dealStatusParam = event.data.preMatchedStatus ?? '';
                this.inquiryIdParam = event.data.inquiryIds ?? [];
                this.inquiriesObjectParam = event.data.inquiries ?? [];
              }
              sessionStorage.setItem('currentTab', this.folderName);
              this.userDataService.httpGetLoginUserInfo();
              this.loginService();
            });
          }
        } else {
          this.notShowMicroUi = true;
        }
      });
    }
  }

  loginService(): void {
    this.userDataService.getServiceStatus().subscribe(status => {
      this.loginUserInfo = status;
      if (this.loginUserInfo) {
        this.userDataService.LocalGetLoginUserInfo().subscribe((data) => {
          const productFamilyFromLoginUser = data.productFamilyGroupIdMap;
          const numberOfDays = data.searchInDays;
          const bussinessStartDate = data.bussinessStartDate;
          let tabNameForIframe = this.folderName.toLowerCase();
          tabNameForIframe = tabNameForIframe.charAt(0).toUpperCase() + tabNameForIframe.slice(1);
          this.microfrontendInboxService.formRequestObjectOfGrid(
            tabNameForIframe,
            this.inquiryIdParam,
            this.productFamilyParam,
            productFamilyFromLoginUser,
            numberOfDays,
            this.inquiriesObjectParam,
            bussinessStartDate
          );
        });
      }
    });
  }

  // Layout helpers used by the template to hide main content
  // on logout and error routes. Route detection is owned by
  // AuthOrchestratorService.
  get isLogoutRoute(): boolean {
    return this.authOrchestrator.isLogoutRouteActive();
  }

  get isErrorRoute(): boolean {
    return this.authOrchestrator.isErrorRouteActive();
  }
}
